// export const ApiEndpoint = "http://3.128.185.8:5001/api";
// export const ApiEndpoint = "http://3.18.212.245:5001/api";
export const ApiEndpoint = "https://spm.cnexco.com/api/api";
// export const ApiEndpoint = "https://sheltered-dawn-68271.herokuapp.com/http://18.191.112.47:5001/api";
// export const ApiEndpoint = "http://123.25.30.61:5002/api";
// export const ApiEndpoint = "https://localhost:6001/api";
// export const ApiEndpoint = "http://14.224.134.120:195/api/api";
